import roles from 'consts/roles';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep, isArray } from 'lodash';
import { useMemo } from 'react';
import { IsJsonString } from 'helpers';
import ColumnMonitoringModel from 'models/column-monitoring.model';
import { getUser } from 'redux/actions/userActions';

export default () => {
  const isLogin = useSelector((state) => state.authReducer.isLogin);
  const user = useSelector((state) => state?.userReducer?.data);
  const dispatch = useDispatch();

  const userMemo = useMemo(() => {
    if (isLogin) {
      const nextUser = cloneDeep(user);
      const campaignMonitoringLayout = nextUser?.settings?.campaignMonitoringLayout;

      nextUser.isLogged = true;
      nextUser.isSuperAdmin = (user?.roles || []).includes(roles.superAdmin);
      nextUser.routesInfo = isArray(user?.routes) ? user.routes : [];
      nextUser.refetch = () => dispatch(getUser({ refetch: true }));

      nextUser.monitoringV1Layout =
        (campaignMonitoringLayout &&
          IsJsonString(campaignMonitoringLayout) &&
          JSON.parse(campaignMonitoringLayout)?.v1) ||
        new ColumnMonitoringModel().columns;
      nextUser.monitoringV2Layout =
        (campaignMonitoringLayout &&
          IsJsonString(campaignMonitoringLayout) &&
          JSON.parse(campaignMonitoringLayout)?.v2) ||
        [];

      return nextUser;
    }

    return {};
  }, [isLogin, user, dispatch]);

  return userMemo;
};
